import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function PTWhatIs() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-1797">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-1798">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-1799">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-1800">
            WHAT IS PDO THREADING?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-1801"></div>

          <p className="text-black text-lg leading-[1.8] font-body mb-12" data-id="element-1802">
            PDO (Polydioxanone) threads are a minimally invasive cosmetic
            procedure used for addressing issues with aging skin.
          </p>

          {/* Pull Quote */}
          <div className="relative max-w-[700px] mx-auto mb-12" data-id="element-1803">
            <div className="text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-60 mb-2" data-id="element-1804">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.6]" data-id="element-1805">
              PDO Threads tighten, lift, and rejuvenate sagging skin while
              promoting collagen production, delivering natural-looking,
              long-lasting results.
            </p>
          </div>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-1806">
            <p data-id="element-1807">
              These threads are made of a biocompatible synthetic material
              called polydioxanone, that has been widely used in medical sutures
              for years. PDO Threads work by stimulating collagen production and
              supporting tissue structure, resulting in firmer, smoother and
              more youthful-looking skin.
            </p>
            <p data-id="element-1808">
              What's amazing about PDO Threads is their versatility! For
              example, smooth threads can be used superficially in cross hatch
              patterns to stimulate collagen formation. This is effective at
              reducing fine lines and wrinkles. Lifting threads are very
              different as they pull up the skin, improving sagging skin and
              folds.
            </p>
            <p data-id="element-1809">
              While the threads themselves gradually dissolve over several
              months, the collagen stimulation they initiate can continue to
              improve skin quality and firmness even after the threads have
              disappeared.
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}